import { Container, Title, Group, Button, Text } from "@mantine/core"
import { IconArrowBackUp } from "@tabler/icons-react"
import { NotFoundRouteComponent } from '@tanstack/react-router'

export const PageNotFound: NotFoundRouteComponent = () => {

    return (
        <div className="w-full h-full flex flex-col items-center justify-around bg-linear-to-tr from-slate-900 to-slate-700 relative">
            <Container>
                <Text c={'dimmed'} className={'text-center font-bold! text-4xl! md:text-5xl!'} style={{ marginBottom: 'calc(1.5 * var(--mantine-spacing-xl))' }}>404</Text>
                <Title c={'white'} className={'text-center font-bold text-3xl! md:text-4xl!'}>Sorry, this page doesn't seem to exist...</Title>
                <Group justify="center">
                    <Button mt={100} leftSection={<IconArrowBackUp size={18}/>} size="md">
                        Take me back
                    </Button>
                </Group>
            </Container>
        </div>
    )
}